










import { Component, Vue } from "vue-property-decorator";
import TrialPitInputForm from "./components/TrialPitInputForm.vue";

@Component({
  components: {
    TrialPitInputForm
  }
})
export default class App extends Vue {
  private lastHeight: number = 0;
  private SIMPLFiUrl: string = "";

  protected async mounted() {
    const environment = await (await fetch("/Environment.json")).json();
    this.SIMPLFiUrl = environment.SIMPLFiUrl;

    const w: Window &
      typeof globalThis & {
        cetiTrialPit?: { trialPitInputForm?: TrialPitInputForm };
      } = window;
    w.cetiTrialPit = {};
    w.cetiTrialPit.trialPitInputForm = this.$refs
      .trialPitInputForm as TrialPitInputForm;

    w.addEventListener("message", ev => {
      if (ev.origin === this.SIMPLFiUrl) {
        switch (ev.data.type) {
          case "GetTrialPitJson":
            const pit = w.cetiTrialPit!.trialPitInputForm!.getTrialPit();
            (ev.source as Window).postMessage(
              {
                type: "SendTrialPitJson",
                data: JSON.stringify(pit)
              },
              this.SIMPLFiUrl
            );
            break;
          case "GetTrialPitImage":
            const pitImage = w.cetiTrialPit!.trialPitInputForm!.getTrialPitImage();
            (ev.source as Window).postMessage(
              {
                type: "SendTrialPitImage",
                data: pitImage
              },
              this.SIMPLFiUrl
            );
            break;
          case "SetTrialPitJson":
            (this.$refs
              .trialPitInputForm as TrialPitInputForm).loadTrialPitFromJson(
              ev.data.data
            );
            break;
        }
      }
    });

    if (this.$refs["main-container"] && window.parent) {
      this.monitorHeight();
    }
  }

  private monitorHeight() {
    const container = this.$refs["main-container"] as HTMLElement;
    if (this.lastHeight !== container.clientHeight) {
      this.lastHeight = container.clientHeight;

      if (window.parent) {
        window.parent.postMessage(
          { type: "TrialPitResize", data: this.lastHeight },
          this.SIMPLFiUrl
        );
      }
    }

    window.requestAnimationFrame(this.monitorHeight);
  }
}
